import { FileQuestion } from 'lucide-react';
import { Button } from '@/components/Button.tsx';

export function NotFoundPage() {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-background px-4">
      <FileQuestion className="mb-4 h-16 w-16 text-foreground-subtle" />
      <h1 className="mb-2 text-2xl font-semibold text-foreground">Page not found</h1>
      <p className="mb-6 text-foreground-muted">
        The page you're looking for doesn't exist or has been moved.
      </p>
      <Button variant="primary" onClick={() => (window.location.href = '/')}>
        Go to Dashboard
      </Button>
    </div>
  );
}
